import { render, staticRenderFns } from "./GroupIns.vue?vue&type=template&id=4115805d&scoped=true"
import script from "./GroupIns.vue?vue&type=script&lang=js"
export * from "./GroupIns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115805d",
  null
  
)

export default component.exports